import { makeAutoObservable } from 'mobx'
import CheckableMap from 'src/models/CheckableMap'

import { ArithmeticCurriculumKeyWorksheet } from './ArithmeticCurriculumKeyWorksheet'
import { Worksheet } from './Worksheet'

export class ArithmeticWorksheetColl<
  T extends Worksheet | ArithmeticCurriculumKeyWorksheet = Worksheet
> {
  constructor(private workSheetMap: CheckableMap<T['id'], T>) {
    makeAutoObservable(this)
  }

  get toArr() {
    return [...this.workSheetMap.values()]
  }

  get checkSize() {
    return this.workSheetMap.checkSize
  }

  get checkedIds() {
    return this.workSheetMap.toCheckedKeys
  }

  get toCheckedValues() {
    return this.workSheetMap.toCheckedValues
  }

  get toOrderedCheckedValues() {
    return this.workSheetMap.toCheckedValues.sort((prev, cur) => prev.id - cur.id)
  }

  toggleCheck(key) {
    return this.workSheetMap.toggleCheck(key)
  }

  isChecked(key) {
    return this.workSheetMap.isChecked(key)
  }

  get isAllChecked() {
    return this.workSheetMap.isFullyChecked
  }

  get isPartiallyChecked() {
    return this.workSheetMap.isPartChecked
  }

  toggleAllCheck() {
    return this.workSheetMap.toggleAllCheck()
  }

  clearAllCheck() {
    return this.workSheetMap.clearAllCheck()
  }

  updateWorksheet(arithmeticWorksheet: T) {
    const selected = this.workSheetMap?.get(arithmeticWorksheet.id)
    if (selected) {
      selected.update(arithmeticWorksheet.toJS())
    }
  }

  adds(workSheetColl: ArithmeticWorksheetColl<T>) {
    this.workSheetMap.adds(workSheetColl.workSheetMap.entries())
  }
}
